import { render, staticRenderFns } from "./integralGoods.vue?vue&type=template&id=554dc22d&scoped=true&"
import script from "./integralGoods.vue?vue&type=script&lang=js&"
export * from "./integralGoods.vue?vue&type=script&lang=js&"
import style0 from "./integralGoods.vue?vue&type=style&index=0&id=554dc22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554dc22d",
  null
  
)

component.options.__file = "integralGoods.vue"
export default component.exports